import { render, staticRenderFns } from "./OrgList.vue?vue&type=template&id=29a37346&"
import script from "./OrgList.vue?vue&type=script&lang=ts&"
export * from "./OrgList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports